import React, {useEffect, useRef, useState} from "react";
import {CheckoutInfoResponse} from "../../../types/CheckoutInfoResponse";
import {Result} from "antd";
import WrappedCard from "../../antd/WrappedCard";

type KaroPayTypeProps = {
    getCheckoutInfoData: CheckoutInfoResponse;
};

const ACTION_URL =
    "https://ipg1.apps.net.pk/Ecommerce/api/Transaction/PostTransaction";

const PkPayFastRedirectMode = ({getCheckoutInfoData}: KaroPayTypeProps) => {
    const defaultFormData = {
        BASKET_ID: String(getCheckoutInfoData.orderId),
        MERCHANT_ID: getCheckoutInfoData.merchantId!,
        TOKEN: getCheckoutInfoData.accessToken!,
        TXNAMT: getCheckoutInfoData.txnAmt!,
        PROCCODE: getCheckoutInfoData.prodCode!,
        SIGNATURE: getCheckoutInfoData.signature!,
        TXNDESC: getCheckoutInfoData.txnDesc!,
        SUCCESS_URL:
            getCheckoutInfoData.successUrl!,
        FAILURE_URL:
            getCheckoutInfoData.failureUrl!,
        ORDER_DATE: getCheckoutInfoData.orderDate!,
        CHECKOUT_URL:
            getCheckoutInfoData.checkoutUrl!,
        CUSTOMER_MOBILE_NO: getCheckoutInfoData.customerPhone!,
        CUSTOMER_EMAIL_ADDRESS: getCheckoutInfoData.customerEmail!
    };

    const formRef = useRef<HTMLFormElement>(null);
    const [formData, setFormData] = useState(defaultFormData);

    useEffect(() => {
        if (getCheckoutInfoData && formRef.current) {
            formRef.current.submit()
        }
    }, [getCheckoutInfoData]);

    return (
        <>
            {getCheckoutInfoData.checkoutStatus !== "SUBMITTED" && (
                <WrappedCard>
                    <Result
                        title="Please wait, we're reidrecting you to PayFast."
                    />
                    <form
                        ref={formRef}
                        action={ACTION_URL}
                        method="POST"
                        target="_top"
                        style={{
                            display: "none"
                        }}
                    >
                        {Object.entries(formData).map(([key, value]) => {
                            return (
                                <input
                                    type={"hidden"}
                                    key={key}
                                    name={key}
                                    value={value}
                                />
                            );
                        })}
                    </form>
                </WrappedCard>
            )}
        </>
    );
};

export default PkPayFastRedirectMode;